import * as R from 'ramda';
import { i18n } from '@/plugins/i18n/i18n';

export const validateClientId = (clientId: string): string | true => {
  if (R.test(/^[0-9a-zA-Z\-._]*$/, clientId)) {
    return true;
  } else {
    return i18n.tc('portal.ruleSSMParameterStoreName');
  }
};
